/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentLateRegistrationOption
 */
export interface TournamentLateRegistrationOption {
    /**
     * Minutes after start that registration stays open (0 = not allowed)
     * @type {number}
     * @memberof TournamentLateRegistrationOption
     */
    minutes: number;
    /**
     * Display label (e.g., "15 minutes", "1 hour", "Not allowed")
     * @type {string}
     * @memberof TournamentLateRegistrationOption
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentLateRegistrationOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentLateRegistrationOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentLateRegistrationOption interface.
 */
export function instanceOfTournamentLateRegistrationOption(value: object): value is TournamentLateRegistrationOption {
    if (!('minutes' in value) || value['minutes'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentLateRegistrationOptionFromJSON(json: any): TournamentLateRegistrationOption {
    return TournamentLateRegistrationOptionFromJSONTyped(json, false);
}

export function TournamentLateRegistrationOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentLateRegistrationOption {
    if (json == null) {
        return json;
    }
    return {
        
        'minutes': json['minutes'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentLateRegistrationOptionToJSON(json: any): TournamentLateRegistrationOption {
    return TournamentLateRegistrationOptionToJSONTyped(json, false);
}

export function TournamentLateRegistrationOptionToJSONTyped(value?: TournamentLateRegistrationOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minutes': value['minutes'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

